import { request } from '@/shared/api/request'

export const delXMLEmployee = ({params, payload: {wpEmployeeId}}) => {
	return request({
		method: 'GET',
		url: `staff/wplace/xmlEsutdDel/${wpEmployeeId}`,
		params: params
	})
}
